import React from "react";
import Register from "./Register";

const RegisterUser = () => {
	return <Register />;
};

export default RegisterUser;
